export enum CurrencyType {
  TL,
  USD,
  EUR
}
